import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["compact", "expanded", "prompts"]

    connect() {
        this.isLocked = false
        this.isExpanded = false
        this.boundMessageHandler = this.handleParentMessage.bind(this)
        window.addEventListener('message', this.boundMessageHandler)

        // Listen for successful form submission to hide prompts
        this.boundFormSubmitHandler = this.handleFormSubmit.bind(this)
        this.element.addEventListener('turbo:submit-end', this.boundFormSubmitHandler)
    }

    disconnect() {
        window.removeEventListener('message', this.boundMessageHandler)
        this.element.removeEventListener('turbo:submit-end', this.boundFormSubmitHandler)
    }

    handleFormSubmit(event) {
        if (event.detail.success) {
            this.hidePrompts()
        }
    }

    hidePrompts() {
        this.promptsTargets.forEach(el => el.remove())
    }

    handleParentMessage(event) {
        if (!event.data || !event.data.type) return

        switch (event.data.type) {
            case 'ai_mode_expand':
                if (!this.isLocked) {
                    this.expand()
                }
                break
            case 'ai_mode_collapse':
                if (!this.isLocked) {
                    this.collapse()
                }
                break
            case 'ai_mode_lock':
                this.lock()
                break
        }
    }

    mouseEnter() {
        if (!this.isLocked) {
            this.expand()
            this.notifyParent('expanded')
        }
    }

    mouseLeave() {
        // Don't collapse if locked or if compact layer was removed (user engaged)
        if (!this.isLocked && this.hasCompactTarget) {
            this.collapse()
            this.notifyParent('collapsed')
        }
    }

    lock() {
        this.isLocked = true
        this.expand()
        this.notifyParent('locked')
    }

    expand() {
        if (this.isExpanded) return
        this.isExpanded = true

        if (this.hasCompactTarget && this.hasExpandedTarget) {
            // Fade out compact layer
            this.compactTarget.classList.add("opacity-0")

            // Show expanded layer and fade in
            this.expandedTarget.classList.remove("invisible")
            void this.expandedTarget.offsetHeight
            this.expandedTarget.classList.remove("opacity-0")
            this.expandedTarget.classList.add("opacity-100")

            // Hide compact after transition
            setTimeout(() => {
                if (this.isExpanded && this.hasCompactTarget) {
                    this.compactTarget.classList.add("invisible")
                }
            }, 250)
        }
    }

    collapse() {
        if (!this.isExpanded) return
        this.isExpanded = false

        if (this.hasCompactTarget && this.hasExpandedTarget) {
            // Fade out expanded layer
            this.expandedTarget.classList.remove("opacity-100")
            this.expandedTarget.classList.add("opacity-0")

            // Show compact layer and fade in
            this.compactTarget.classList.remove("invisible")
            void this.compactTarget.offsetHeight
            this.compactTarget.classList.remove("opacity-0")

            // Hide expanded after transition
            setTimeout(() => {
                if (!this.isExpanded && this.hasExpandedTarget) {
                    this.expandedTarget.classList.add("invisible")
                }
            }, 250)

            // Resume swiper autoplay
            setTimeout(() => {
                window.dispatchEvent(new CustomEvent('prompts-swiper:resume'))
            }, 300)
        }
    }

    notifyParent(state) {
        window.parent.postMessage({ type: 'ai_mode_prompts_state', state: state }, '*')
    }
}
